import { Box, TableContainer } from "@material-ui/core";
import { FC, useEffect, useMemo, useState } from "react";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import Loader from "router/components/Loader";
import { useStyles } from "./styles";
import PayrollHead from "./PayrollHead";
import PayrollStats from "./PayrollStats";
import PayrollTable from "./PayrollTableBody";
import { useTableSync } from "hooks/useTableSync";
import { getFilteredPayrollRows } from "utils/payrollHelpers";
import PaginationSwitch from "componentsNew/elements/PaginationSwitch";

interface PropsType {}

const PayrollPage: FC<PropsType> = () => {
  const classes = useStyles();
  const { loadingData, dataList, payrollFilters } = useTypeSelectors((state) => state.payrollTable);
  const { t1Ref, t2Ref } = useTableSync();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const totalCount = useMemo(
    () =>
      getFilteredPayrollRows(
        dataList,
        payrollFilters.ordering,
        payrollFilters.search,
        payrollFilters.station,
        payrollFilters.userRole,
        payrollFilters.userStatus,
        payrollFilters.user?.id,
      ).length,
    [
      dataList,
      payrollFilters.ordering,
      payrollFilters.search,
      payrollFilters.station,
      payrollFilters.userRole,
      payrollFilters.userStatus,
      payrollFilters.user?.id,
    ],
  );

  useEffect(() => {
    setPage(0);
  }, [
    payrollFilters.search,
    payrollFilters.station,
    payrollFilters.userRole,
    payrollFilters.userStatus,
    payrollFilters.user?.id,
    payrollFilters.ordering,
    payrollFilters.week_date,
    payrollFilters.type,
    payrollFilters.month,
    payrollFilters.year,
    payrollFilters.rangeDateOne,
    payrollFilters.rangeDateTwo,
  ]);

  const handleChangePage = (_event: unknown, value: number) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  return (
    <Box className={classes.root}>
      <Loader isLoading={loadingData} />
      <PayrollHead />
      <PayrollStats />
      <Box className={classes.contentBox}>
        <Box style={{ display: "flex" }}>
          <TableContainer className={classes.tableContainer} ref={t1Ref} key="schedulecontainer1">
            <PayrollTable tableNumber={1} page={page} rowsPerPage={rowsPerPage} />
          </TableContainer>
          <TableContainer className={classes.tableContainer2} ref={t2Ref} key="schedulecontainer2">
            <PayrollTable tableNumber={2} page={page} rowsPerPage={rowsPerPage} />
          </TableContainer>
        </Box>
        <Box className={classes.tableFooter}>
          <PaginationSwitch
            page={page}
            rowsPerPage={rowsPerPage}
            totalPages={totalCount}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PayrollPage;
